import React from "react";

export const UiGrayCard = (props) => {
  return (
    <>
      <div className="df-gray-rounded-card">{props.children}</div>
    </>
  );
};
